const topics = [
  { tag: '科幻巨制', count: '2.8万讨论', hot: true },
  { tag: '国产动画崛起', count: '2.1万讨论', hot: true },
  { tag: '经典港片修复', count: '1.9万讨论', hot: true },
  { tag: '暑期观影指南', count: '3.5万讨论', hot: true },
  { tag: '院线新片', count: '2.3万讨论', hot: false },
  { tag: '悬疑烧脑', count: '1.6万讨论', hot: false },
  { tag: '女性电影专题', count: '1.2万讨论', hot: false },
  { tag: '独立电影', count: '0.9万讨论', hot: false },
  { tag: '4K蓝光体验', count: '1.8万讨论', hot: true },
  { tag: '电影原声', count: '1.4万讨论', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 border border-primary-200 mb-4">
            <i className="ri-hashtag text-primary-600 text-sm"></i>
            <span className="text-xs font-medium text-primary-700 whitespace-nowrap">话题热议</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-50">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-200 max-w-lg mx-auto">
            影迷们正在热烈讨论的电影话题，加入交流发现更多好片
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#comments"
              className={`group flex items-center gap-2.5 px-5 py-3 rounded-full cursor-pointer transition-all duration-200 border ${
                topic.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100'
                  : 'bg-background-50 border-background-200 hover:bg-background-200/60'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
              <span className={`text-sm font-medium whitespace-nowrap ${
                topic.hot ? 'text-accent-800' : 'text-foreground-100'
              }`}>
                #{topic.tag}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-accent-500' : 'text-foreground-300'
              }`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}